<template>
    <a-modal
             v-model="visible"
             centered

    >
        <template slot="title">
            <p>
                <a-icon type="clock-circle" style="color: blue" />
                Info
            </p>
        </template>
        <div class="notification-container"><p>Vi holder nå stengt for bestilling.</p>
        <p>
            Du kan bestille fra <b>{{ openingTime.canOrderFrom }} - {{ openingTime.cannotOrderFrom }}</b> 
        </p>
        <p>
            Åpningstider : <b>{{ openingTime.fromTime }} - {{ openingTime.toTime }}</b>
        </p></div>
        
        <template slot="footer">
            <div class="button-flex">     
                <a-button @click="handleBtnOK" class="modal-btn">
                    OK
                </a-button>
            </div>
       
        </template>
    </a-modal>
</template> 

<script>

export default {
    props : {
       
    },
    data() {
        return {
            visible : false,
            openingTime : {
                canOrderFrom : '',
                cannotOrderFrom : '',
                fromTime : '',
                toTime : ''
            }
        }
    },
    computed : {
        
    },
    methods : {
        showModal() {
            this.openingTime = this.$store.getters['restaurants/currentRestaurantOpeningTime'];
            this.visible = true;
        },
        handleBtnOK() {
            this.visible = false;
        }
    },
    created () {
        //console.log('notification modal is created')
    }
}
</script>

<style lang="scss" >
    /* Overides antVue css*/
.modal-btn {

width: 30%;

&.ant-btn{
      border-color: #000000 ;
  border: 0.5px solid #000000 ;
  
  border-radius: 0px;
  height: 3.5em;
  font-family: Bebas, sans-serif;
  font-size: 1.5em;
  background-color: #f8f8f8;
}

}

.notification-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: bebas;
    font-size: 18px;
    letter-spacing: 1px;

}

.button-flex{
    display: flex;
    justify-content: center;
    
}

</style>